const audioPlayer = {
    play: (fileName) => {
        return new Promise((resolve, reject) => {
            if (window.cordova && window.cordova.plugins && window.cordova.plugins.SonicPlayer) {
                window.cordova.plugins.SonicPlayer.play(fileName, resolve, err => reject('Cordova Sonic plugin error: ' + err));
            } else {
                reject('Cordova Sonic plugin error: plugin not available');
            }
        });
    },

    pause: () => {
        return new Promise((resolve, reject) => {
            if (window.cordova && window.cordova.plugins && window.cordova.plugins.SonicPlayer) {
                window.cordova.plugins.SonicPlayer.pause(resolve, err => reject('Cordova Sonic plugin error: ' + err));
            } else {
                reject('Cordova Sonic plugin error: plugin not available');
            }
        });
    },

    resume: () => {
        return new Promise((resolve, reject) => {
            if (window.cordova && window.cordova.plugins && window.cordova.plugins.SonicPlayer) {
                window.cordova.plugins.SonicPlayer.resume(resolve, err => reject('Cordova Sonic plugin error: ' + err));
            } else {
                reject('Cordova Sonic plugin error: plugin not available');
            }
        });
    },

    stop: () => {
        return new Promise((resolve, reject) => {
            if (window.cordova && window.cordova.plugins && window.cordova.plugins.SonicPlayer) {
                window.cordova.plugins.SonicPlayer.stop(resolve, err => reject('Cordova Sonic plugin error: ' + err));
            } else {
                reject('Cordova Sonic plugin error: plugin not available');
            }
        });
    },

    setSpeed: (speed) => {
        return new Promise((resolve, reject) => {
            if (window.cordova && window.cordova.plugins && window.cordova.plugins.SonicPlayer) {
                window.cordova.plugins.SonicPlayer.setSpeed(speed, resolve, err => reject('Cordova Sonic plugin error: ' + err));
            } else {
                reject('Cordova Sonic plugin error: plugin not available');
            }
        });
    }
};

export default audioPlayer;
